angular.module('dnecom')
    .controller('StoreHomePageController', StoreHomePageController);

StoreHomePageController.$inject = ['$scope', '$rootScope', '$http', 'notifications', 'StoreUtils', 'MediaSrc'];

/**
 * @typedef {{id: int, name: string, title: string, slug: string, isDisplay: boolean}} Collection
 */
function StoreHomePageController($scope, $rootScope, $http, notifications, StoreUtils, MediaSrc) {
    const store = TemplateData.value('store');
    const props = _.get(store, ['properties', 'kibo']);
    const defaultColor = '#13CD00';
    const defaultTitleColor = '#000000';
    const defaultBackgroundColor = '#ffffff';
    const defaultOpacity = 1;
    const vm = this;

    /** @type {[Collection]} collections */
    vm.collections = [];
    vm.isHomePageEnabled = _.get(props, ['home_page_enabled'], false);
    /** @type {Collection} vm.selectedCollectionModel */
    vm.selectedCollectionModel = {};
    vm.coverImage = _.get(props, ['home_page_coverImage_media'], null);
    vm.coverImageId = _.get(props, ['home_page_coverImage'], null);
    vm.coverImageSrc = vm.coverImage? MediaSrc.src(vm.coverImage) : null;
    vm.shortDescription = _.get(props, ['home_page_shortDescription'], null);
    vm.buttonText = _.get(props, ['home_page_buttonText'], null);
    vm.color = _.get(props, ['home_page_color'], defaultColor);
    vm.titleColor = _.get(props, ['home_page_titleColor'], defaultTitleColor);
    vm.backgroundColor = _.get(props, ['home_page_backgroundColor'], defaultBackgroundColor);
    vm.collectionTitle = _.get(props, ['home_page_collectionTitle'], null);
    vm.backgroundOpacity = _.get(props, ['home_page_backgroundOpacity'], defaultOpacity) * 100;
    vm.errorMessages = [];
    vm.noCollectionCreatedYet = false;
    vm.cropperInited = false;
    vm.croppX = 0;
    vm.croppY = 0;
    vm.croppWidth = 0;
    vm.croppHeight = 0;
    vm.height = parseInt(_.get(props, ['home_page_coverHeight'], 320));
    vm.adjustedHeight = vm.height * 0.56;
    vm.uiSelectCollectionId = '';
    vm.save = save;

    vm.setCover = file =>
        StoreUtils.upload(store, file, function (media) {
            vm.errorMessages = [];
            vm.coverImageId = media.id;
            vm.coverImage = media;
            vm.coverImageSrc = MediaSrc.src(media);
            vm.initCropper();
        });

    vm.checkLength = (field, maxLength) => {
        if (vm[field] && vm[field].length > maxLength) {
            vm[field] = vm[field].substring(0, maxLength);
        }
    };

    $scope.$on('cropper:init', function () {
        vm.initCropper();
    });

    vm.initCropper = function () {
        if (!vm.cropperInited) {
            var $image = $('#image');

            $image.cropper({
                viewMode: 3,
                dragMode: 'move',
                autoCropArea: 1,
                restore: false,
                modal: false,
                guides: false,
                highlight: false,
                cropBoxMovable: false,
                cropBoxResizable: false,
                toggleDragModeOnDblclick: false,
                zoomOnWheel: false,

                crop: function (event) {
                    vm.croppX = event.detail.x;
                    vm.croppY = event.detail.y;
                    vm.croppWidth = event.detail.width;
                    vm.croppHeight = event.detail.height;

                }
            });
            // Get the Cropper.js instance after initialized
            var cropper = $image.data('cropper');
            vm.cropperInited = !!cropper;
        }
    }

    vm.zoomIn = function () {
        var $image = $('#image');

        $image.cropper('zoom', 0.1)
    }
    vm.zoomOut =  function () {
        var $image = $('#image');

        $image.cropper('zoom', -0.1)
    }

    vm.reinitImgCroper = function () {
        var $image = $('#image');
        vm.cropperInited = false;
        $image.cropper('destroy');
        vm.adjustedHeight = vm.height * 0.56;
        vm.initCropper();
    }

    vm.removeCoverImage = function () {
        vm.coverImageSrc = '';
        var $image = $('#image');
        vm.cropperInited = false;
        $image.cropper('destroy');
    }

    vm.setButtonText = text => vm.buttonText = text;
    vm.setColor = color => vm.color = color;
    vm.setTitleColor = color => vm.titleColor = color;
    vm.setBackgroundColor = color => vm.backgroundColor = color;
    vm.getColor = getColor;
    vm.getTitleColor = getTitleColor;
    vm.getBackgroundColor = getBackgroundColor;
    vm.resetColor = resetColor;
    vm.resetTitleColor = resetTitleColor;
    vm.resetBackgroundColor = resetBackgroundColor;
    vm.isDefaultColor = isDefaultColor;
    vm.isDefaultTitleColor = isDefaultTitleColor;
    vm.isDefaultBackgroundColor = isDefaultBackgroundColor;
    vm.isDefaultOpacity = isDefaultOpacity;
    vm.resetOpacity = resetOpacity;
    vm.changeCollection = changeCollection;

    fetchCollections();
    vm.deselectCollection = deselectCollection;
    vm.toggleHomePage = toggleHomePage;

    $scope.$on(
        'store.collection.add-item',
        /**
         * @param {any} event
         * @param {Collection} addedCollection
         * */
        (event, addedCollection) => setLoadedCollections([...vm.collections, addedCollection])
    );

    $scope.$on(
        'store.collection.edit-item',
        /**
         * @param {any} event
         * @param {Collection} affectedCollection
         * */
        (event, affectedCollection) => {
            const collection = _.find(vm.collections, o => o.id === affectedCollection.id);
            const selectedCollectionId = _.get(vm.selectedCollectionModel, ['selected', 'id']);
            collection.name = affectedCollection.name;
            if (!affectedCollection.isDisplay && affectedCollection.id === selectedCollectionId) {
                if (vm.isHomePageEnabled) {
                    toggleHomePage();
                }
                deselectCollection();
            }
        }
    );

    $scope.$on(
        'store.collection.delete-item',
        /**
         * @param {any} event
         * @param {Collection} affectedCollection
         * */
        (event, affectedCollection) => {
            const selectedCollectionId = _.get(vm.selectedCollectionModel, ['selected', 'id']);
            if (affectedCollection.id === selectedCollectionId) {
                if (vm.isHomePageEnabled) {
                    toggleHomePage();
                }
                deselectCollection();
            }
            setLoadedCollections(_.filter(vm.collections, o => o.id !== affectedCollection.id));
        }
    );

    let lock = false;
    function toggleHomePage() {
        if (lock) {
            return;
        }
        lock = true;

        $http.post(
            Routing.generate('stores_update_settings', {id: store.id, group: 'KiboHomePage'}),
            {
                properties: {
                    kiboHomePage: {
                        enabled: vm.isHomePageEnabled = !vm.isHomePageEnabled
                    }
                }
            }
        ).catch(() => {
            vm.isHomePageEnabled = !vm.isHomePageEnabled;
            notifications.danger("Error: could not change Home Page settings.");
        }).finally(() => lock = false);
    }

    function fetchCollections() {
        $http.get(Routing.generate('collections_list', {
            id: store.id,
        })).success(collections => setLoadedCollections(collections));
    }

    /**
     * @param {[Collection]} collections
     */
    function setLoadedCollections(collections) {
        if (collections.length) {
            vm.noCollectionCreatedYet = false;
            vm.collections = collections;
            let selectedCollectionId = _.get(props, ['home_page_collection'], null);
            if (selectedCollectionId !== null) {
                selectedCollectionId = _.toInteger(selectedCollectionId);
                const selectedOption = _.find(vm.collections, o => o.id === selectedCollectionId);
                if (selectedOption && selectedOption.isDisplay) {
                    vm.selectedCollectionModel.selected = selectedOption;
                    vm.uiSelectCollectionId = selectedOption.id;
                } else {
                    deselectCollection();
                }
            }
        } else {
            vm.noCollectionCreatedYet = true;
            vm.collections = [];
            deselectCollection();
            if (vm.isHomePageEnabled) {
                vm.toggleHomePage();
            }
        }
    }

    function save(form) {
        form.$setTouched();

        if (!vm.coverImageId) {
            vm.errorMessages.push({
                type: 'empty_cover',
                text: 'Collection cover is required.'
            });
        }

        if (form.$invalid
            || !vm.selectedCollectionModel.selected.id
            || !vm.coverImageId
            || !vm.color
            || !vm.titleColor
            || vm.backgroundOpacity === null
        ) {
            return;
        }

        $scope.store.properties.kiboHomePage = {
            collection: vm.selectedCollectionModel.selected.id,
            coverImage: vm.coverImageId,
            shortDescription: vm.shortDescription,
            buttonText: vm.buttonText,
            color: vm.color,
            collectionTitle: vm.collectionTitle,
            titleColor: vm.titleColor,
            backgroundColor: vm.backgroundColor,
            backgroundOpacity: vm.backgroundOpacity / 100,
            coverHeight: vm.height,
            crop: {
                croppX: parseInt(vm.croppX),
                croppY: parseInt(vm.croppY),
                croppWidth: parseInt(vm.croppWidth),
                croppHeight: parseInt(vm.croppHeight),
            }
        };

        $scope.$parent.save(form);
        $rootScope.$broadcast('store.homepage-settings.collection.select', vm.selectedCollectionModel.selected.id);

        return true;
    }

    function isDefaultColor() {
        return vm.color === defaultColor;
    }

    function isDefaultTitleColor() {
        return vm.titleColor === defaultTitleColor;
    }

    function isDefaultBackgroundColor() {
        return vm.backgroundColor === defaultBackgroundColor;
    }

    function isDefaultOpacity() {
        return vm.backgroundOpacity / 100 == defaultOpacity;
    }

    function resetOpacity() {
        vm.backgroundOpacity = defaultOpacity * 100;
    }

    function resetColor() {
        vm.color = defaultColor;
    }

    function resetTitleColor() {
        vm.titleColor = defaultTitleColor;
    }

    function resetBackgroundColor() {
        vm.backgroundColor = defaultBackgroundColor;
    }

    function getColor() {
        return vm.color;
    }

    function getTitleColor() {
        return vm.titleColor;
    }

    function getBackgroundColor() {
        return vm.backgroundColor;
    }

    function deselectCollection() {
        vm.selectedCollectionModel = {};
        vm.uiSelectCollectionId = '';
    }

    function changeCollection() {
        if (vm.uiSelectCollectionId && vm.collections.length) {
            vm.collections.forEach(function (item) {
                if (item.id == vm.uiSelectCollectionId) {
                    vm.selectedCollectionModel.selected = item;
                }
            })
        }
    }
}
